import React from 'react'
import { brand } from '../../config/settings/brand'
import routes from '../../config/settings/routes'
import LegalDocument from './LegalDocument'
import {
  InlineLink,
  List,
  MailLink,
  Paragraph,
  SectionTitle,
} from './Legal.styles'

const mailHref = `mailto:${brand.legalContactEmail}`

const Terms = () => (
  <LegalDocument
    title="Términos y Condiciones"
    description={`Términos de uso de ${brand.name}, servicio de seguimiento de pensión alimenticia en Chile.`}
  >
    <Paragraph>
      Estos términos regulan el uso de {brand.name} ({brand.url}), un servicio
      de seguimiento de pensión alimenticia en Chile, prestado bajo la marca
      comercial {brand.legalOperatorBrand}. Al continuar con Google aceptas
      estos términos y la{' '}
      <InlineLink to={routes.privacy}>Política de Privacidad</InlineLink>.
    </Paragraph>

    <SectionTitle>Qué es y qué no es</SectionTitle>
    <Paragraph>{brand.disclaimer}</Paragraph>
    <Paragraph>
      {brand.name} estima el monto del mes según el método y el factor que tú
      registras (UTM o porcentaje del sueldo mínimo) y según valores de
      referencia públicos. No es un estudio jurídico, no representa a ninguna
      de las partes, no cobra la pensión ni sustituye la resolución del
      tribunal.
    </Paragraph>

    <SectionTitle>Cuenta</SectionTitle>
    <List>
      <li>
        El alta es con Google. Eres responsable de esa cuenta y de la
        veracidad de los datos que ingresas (método, factor, día de pago).
      </li>
      <li>
        El servicio está pensado para la persona que paga pensión alimenticia
        en Chile (alimentante), no para quien la recibe.
      </li>
      <li>
        Podemos suspender una cuenta si hay abuso, riesgo de seguridad o uso
        ajeno a estos términos.
      </li>
    </List>

    <SectionTitle>Uso permitido</SectionTitle>
    <Paragraph>
      Puedes usar {brand.name} para tu propio seguimiento. No está permitido
      intentar acceder a cuentas ajenas, extraer datos de otros usuarios,
      sobrecargar el servicio ni usar la plataforma para cobrar, amenazar o
      hostigar.
    </Paragraph>

    <SectionTitle>Montos y avisos</SectionTitle>
    <Paragraph>
      El monto que ves es una estimación a partir de tu configuración y de la
      UTM o el IMM vigentes en nuestras fuentes. Si tu resolución dice otra
      cosa, prima la resolución. Los recordatorios por correo e in-app son una
      ayuda; no garantizan que pagues a tiempo ni evitan consecuencias legales
      de un atraso.
    </Paragraph>

    <SectionTitle>Correos del servicio</SectionTitle>
    <Paragraph>
      Al crear la cuenta podemos enviarte un correo de bienvenida, un
      recordatorio si no terminas de configurar, el monto estimado del mes y
      avisos cerca del día de pago que indiques. Son mensajes del servicio, no
      publicidad de terceros.
    </Paragraph>

    <SectionTitle>Datos personales</SectionTitle>
    <Paragraph>
      El tratamiento de tus datos se describe en la{' '}
      <InlineLink to={routes.privacy}>Política de Privacidad</InlineLink>. Para
      acceder, rectificar o pedir la eliminación de tu cuenta, escribe a{' '}
      <MailLink href={mailHref}>{brand.legalContactEmail}</MailLink>.
    </Paragraph>

    <SectionTitle>Disponibilidad y responsabilidad</SectionTitle>
    <Paragraph>
      El servicio se ofrece “tal cual”, en la medida de lo posible. No
      respondemos por daños indirectos, lucro cesante ni por el resultado de
      un juicio o de un pago. Nuestra responsabilidad, si la hubiera, se limita
      a lo que permite la ley chilena para este tipo de herramienta gratuita
      de seguimiento.
    </Paragraph>

    <SectionTitle>Cambios</SectionTitle>
    <Paragraph>
      Podemos actualizar estos términos. La fecha de esta página indica la
      versión vigente. Si el cambio es sustancial y tienes cuenta, el aviso
      puede ir también por correo o dentro del producto.
    </Paragraph>

    <SectionTitle>Ley aplicable</SectionTitle>
    <Paragraph>
      Estos términos se rigen por las leyes de la República de Chile. Para
      cualquier consulta:{' '}
      <MailLink href={mailHref}>{brand.legalContactEmail}</MailLink>.
    </Paragraph>
  </LegalDocument>
)

export default Terms
